import { formatCurrency, formatPercentage } from './formatHelper.mjs';

/**
 * Formats number values, based on typical guideJS / mm-web format cases
 * @param {string} format
 * @param {string | number | Array} value
 * @returns {*}
 */
const formatNumberQuestionValues = (format, value) => {
  const valueIsValid = value || value === 0;
  const valueIsArray = Array.isArray(value);
  switch (format) {
    case '%':
    case 'percent':
      return valueIsArray ? value.map(formatPercentage) : valueIsValid
        ? formatPercentage(value) : '';
    case '$':
    case 'money':
    case 'currency':
      return valueIsArray ? value.map(formatCurrency) : valueIsValid
        ? formatCurrency(value) : '';
    case 'number':
      return valueIsArray ? value.map((v) => v.toLocaleString()) : valueIsValid
        ? value.toLocaleString() : '';
    default:
      return value;
  }
};

/**
 * Common function that builders should use retrieve linked questions from a question group object
 *
 * @param {Object} questionGroup: Question group object which holds all the questions for a given view
 * @param {Array} linkedQuestionKeys: array of appkeys for questions we want to return from the question group
 * @returns {*}
 */
const getLinkedQuestions = (questionGroup, linkedQuestionKeys = []) => {
  return linkedQuestionKeys
    .map((appkey) => {
      return questionGroup.questions.find((q) => q.appkey === appkey);
    })
    .filter((q) => q);
};

/**
 * Common function that builders should use to render linked question. Necessary to ensure that the validation reducer runs for
 * linked questions once a builder question is changed
 *
 * @param {Object} linkedQuestion: QuestionShape object to be rendered in the builder
 * @param {Function} linkedQuestionValueChanged: decorator function that runs after value has changed for the Question
 * @param {Function} renderQuestion: function that renders the linkedQuestion. Typically comes from QuestionGroupContainer.jsx
 * @returns {*}
 */
const renderLinkedQuestion = (
  linkedQuestion,
  linkedQuestionValueChanged,
  renderQuestion
) => {
  const onLinkedQuestionValueChange = ({ value, saveChangedValue }) => {
    saveChangedValue(value);
    linkedQuestionValueChanged(linkedQuestion, value);
  };

  return renderQuestion({
    ...linkedQuestion,
    attributes: {
      ...(linkedQuestion.attributes || {}),
      valueChanged: onLinkedQuestionValueChange,
    },
  });
};

export {
  formatNumberQuestionValues,
  getLinkedQuestions,
  renderLinkedQuestion
};
